import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from 'utils/constants'

export default function usePunchedInUsers() {
  return useQuery([QueryKeys.PUNCHED_IN_USERS], () => Promise.resolve([]), {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  })
}
